import { createContext, useContext, useEffect, useRef } from 'react';
import { RealtimeManager } from '@/lib/realtimeManager';

const RealtimeContext = createContext<RealtimeManager | null>(null);

export function RealtimeProvider({ children }: { children: React.ReactNode }) {
  const managerRef = useRef<RealtimeManager>(new RealtimeManager());

  useEffect(() => {
    return () => {
      managerRef.current.destroy();
    };
  }, []);

  return (
    <RealtimeContext.Provider value={managerRef.current}>
      {children}
    </RealtimeContext.Provider>
  );
}

export function useRealtime(): RealtimeManager {
  const manager = useContext(RealtimeContext);
  if (!manager) {
    throw new Error('useRealtime must be used within a RealtimeProvider');
  }
  return manager;
}
